import { useSettings } from 'connectors/Settings/Settings';
import useTranslation from 'next-translate/useTranslation';
import twMerge from 'utils/twMerge';

type ProductStockProps = {
    quantity: number;
    minimumSellingQuantity?: number;
};

export const ProductStock: FC<ProductStockProps> = ({ quantity, minimumSellingQuantity = 1, className }) => {
    const { t } = useTranslation();
    const settings = useSettings();

    const b2bExplicitProductQuantityLimit = settings?.b2bExplicitProductQuantityLimit ?? 10;

    if (quantity < minimumSellingQuantity) {
        return (
            <div className={twMerge('mt-2 text-small font-medium leading-4 text-grayDarker', className)}>
                {t('Unavailable')}
            </div>
        );
    }

    return (
        <div className={twMerge('mt-2 text-small font-medium leading-4 text-green', className)}>
            {quantity > b2bExplicitProductQuantityLimit
                ? `${t('Available > {{ count }} pcs', { count: b2bExplicitProductQuantityLimit })}`
                : `${t('Available {{ quantity }} pcs', { quantity: quantity, count: quantity })}`}
        </div>
    );
};
